var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"referrals"}},[_c('v-treeview',{attrs:{"items":_vm.users,"item-children":"referrals","item-text":""},scopedSlots:_vm._u([{key:"prepend",fn:function({ item }){return [_c('v-icon',{domProps:{"textContent":_vm._s(`mdi-account-network-outline`)}}),_c('span',{class:_vm.getItemClass(item)},[_vm._v(_vm._s(item.email))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }